import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [];

  connect() {
    // Don't show modal on initial page load
    // Listen for Escape key
    this.handleEscape = this.handleEscape.bind(this);
    document.addEventListener("keydown", this.handleEscape);

    // Listen for backdrop clicks
    this.element.addEventListener("click", this.handleBackdropClick.bind(this));

    // Watch for turbo-frame content changes
    const modalContent = this.element.querySelector("#modal_content");
    if (modalContent) {
      // Listen for turbo:frame-load event
      modalContent.addEventListener("turbo:frame-load", () => {
        if (modalContent.innerHTML.trim()) {
          this.show();
        }
      });

      // Also use mutation observer as fallback
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
            // Content was added to the modal, show it
            this.show();
          } else if (
            mutation.type === "childList" &&
            mutation.removedNodes.length > 0 &&
            modalContent.innerHTML.trim() === ""
          ) {
            // Content was removed from the modal, hide it
            this.hide();
          }
        });
      });

      this.observer.observe(modalContent, {
        childList: true,
        subtree: true,
      });
    }
  }

  disconnect() {
    // Clean up event listeners
    document.removeEventListener("keydown", this.handleEscape);

    // Clean up observer
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  show() {
    this.element.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");
  }

  hide() {
    this.element.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
  }

  handleEscape(event) {
    if (event.key === "Escape") {
      this.hide();
    }
  }

  handleBackdropClick(event) {
    // Only close if clicking the backdrop (not the modal content)
    if (event.target === this.element) {
      this.hide();
    }
  }
}
